module.exports = __webpack_public_path__ + "static/media/finger.e30414e9.svg";